<script lang="ts" setup>
import { computed, type PropType } from 'vue'
import { InputSize } from '../../../../interfaces/input'
import { cva } from 'class-variance-authority'

const props = defineProps({
    label: {
        type: String,
        required: true
    },
    size: {
        type: String as PropType<InputSize>,
        default: InputSize.LARGE
    },
    inline: {
        type: Boolean,
        default: false
    },
    isDisabled: {
        type: Boolean,
        default: false
    }
})

const containerStyles = computed(() =>
    cva('flex w-full justify-between', {
        variants: {
            inline: {
                true: 'flex-row',
                false: 'flex-col'
            },
            size: {
                [InputSize.LARGE]: 'gap-2',
                [InputSize.MEDIUM]: 'gap-2',
                [InputSize.SMALL]: 'gap-1'
            }
        }
    })({
        inline: props.inline,
        size: props.size
    })
)

const labelStyles = computed(() =>
    cva('font-medium', {
        variants: {
            size: {
                [InputSize.LARGE]: 'text-[15px] leading-[18px]',
                [InputSize.MEDIUM]: 'text-[13px] leading-4',
                [InputSize.SMALL]: 'text-[11px] leading-[13px]'
            },
            inline: {
                true: 'w-1/2',
                false: 'w-full'
            },
            isDisabled: {
                true: 'text-gray-disabled',
                false: 'text-form-input-content-label-idle'
            }
        }
    })({
        size: props.size,
        inline: props.inline,
        isDisabled: props.isDisabled
    })
)
</script>

<template>
    <div :class="containerStyles">
        <label :class="labelStyles" :for="`input-${label}`">
            {{ label }}
        </label>
        <div :class="inline ? 'w-1/2' : 'w-full'" data-testid="input-container">
            <slot />
        </div>
    </div>
</template>
